import { LayoutModule } from '@angular/cdk/layout';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, Inject, NgModule, PLATFORM_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabNav } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
	AngularSecurityOauthModule, securityInitializerFactory, SECURITY_CONFIG
} from 'angular-security-oauth';
import { ISecurityConfiguration } from 'angular-security-oauth/lib/configuration/ISecurityConfiguration';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { CoreModule } from './commons/core/core.module';
import { BaseHrefApiPreInterceptor } from './commons/core/http/base-href-api.pre-interceptor';
import { DefaultHeadersApiPreInterceptor } from './commons/core/http/default-headers-api.pre-interceptor';
import './commons/rxjs-imports';
import { SharedModule } from './commons/shared/shared.module';
import { MainNavComponent } from './main-nav/main-nav.component';

export function HttpLoaderFactory(platformId: object, http: HttpClient): TranslateHttpLoader {
	const deployUrl = environment.deployUrl || '';
	return new TranslateHttpLoader(http, `${deployUrl}/assets/i18n/`, '.json');
}

export
@NgModule({
	declarations: [AppComponent, MainNavComponent],
	imports: [
		BrowserModule.withServerTransition({ appId: 'my-app' }),
		BrowserAnimationsModule,
		AppRoutingModule,
		CoreModule,
		AngularSecurityOauthModule,
		NgbModule,
		HttpClientModule,
		FormsModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [PLATFORM_ID, HttpClient]
			}
		}),
		SharedModule.forRoot(),
		LayoutModule,
		MatToolbarModule,
		MatButtonModule,
		MatSidenavModule,
		MatIconModule,
		MatListModule
	],
	providers: [
		MatTabNav,
		{
			provide: SECURITY_CONFIG,
			useValue: environment.security as ISecurityConfiguration
		},
		{
			provide: APP_INITIALIZER,
			useFactory: securityInitializerFactory,
			multi: true,
			deps: [SECURITY_CONFIG, KeycloakService],
		},

		{
			provide: HTTP_INTERCEPTORS,
			useClass: BaseHrefApiPreInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: DefaultHeadersApiPreInterceptor,
			multi: true
		}
	],
	bootstrap: [AppComponent]
})
class AppModule {
	constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {}
}
